import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter,
    UncontrolledTooltip, Card, CardBody, CardHeader, ListGroupItem, ListGroup} from "reactstrap";
import { getUsersId, deleteUserKasm, getAdminUsageDump } from "../../../actions/actionAdminUser";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import moment from "moment";
import ReactTable from "react-table";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: false},
    {name: "ViewUser",path:"/viewuser",isActive: true},
];

class ViewUser extends Component{
    constructor(props){
        super(props);
        this.state = {
            modal: false,
            modalreset: false,
            kasmId: null,
            user: null
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteKasm = this.deleteKasm.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    deleteConfirm(kasmId){
        this.setState({modal: !this.state.modal,
            kasmId: kasmId});
    }

    deleteKasm(){
        this.props.deleteUserKasm(this.state.kasmId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    toggle(){
        this.setState({modal: !this.state.modal});
    }

    handleDeleteSuccess(){
        const {deleteUserKasmErrorMessage} = this.props;
        if(deleteUserKasmErrorMessage) {
            NotificationManager.error(deleteUserKasmErrorMessage,"Delete Kasm", 3000);
        }
        else{
            this.setState({modal: false});
            this.props.getUsersId();
            NotificationManager.success("Successfully Deleted User","Delete Kasm", 3000);
        }
    }

    handleDeleteError(){
        const {deleteUsersKasmError} = this.props;
        if(deleteUsersKasmError){
            NotificationManager.error(deleteUsersKasmError,"Delete Kasm", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete User","Delete Kasm", 3000);
        }
    }

    componentDidMount(){
        this.props.getUsersId(this.props.match.params.id);
        this.props.getAdminUsageDump(this.props.match.params.id);
    }

    renderKasms(kasms){
        if(kasms){
            return(
                kasms.map((kasm, i )=>
                    <tr key={i}> 
                        <td>{moment(kasm.keepalive_date).format("L h:mm A")}</td>              
                        <td>{moment(kasm.expiration_date).format("L h:mm A")}</td>            
                        <td>{moment(kasm.start_date).format("L h:mm A")}</td>
                        <td>{kasm.server.hostname}</td>
                        <td>{kasm.server.server_id}</td>
                        <td><button className="btn btn-danger" href="#" id={"Tooltips"} onClick={() => this.deleteConfirm(kasm.kasm_id)}>
                            <i className="fa fa-trash-o"></i></button><UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
                        </td>
                    </tr>
                ));
        }
    }

    renderGroups(groups){
        if (groups){
            return(
                groups.map((group, i)  => 
                    <ListGroupItem key={i}>Group Name : {group.name}</ListGroupItem>
                ));
        }
    } 

    render(){
        const {user, usageDump, usageDumpLoading} = this.props;
        const columns = [{
            Header: "Image Name",
            accessor: "image_friendly_name"
        },
            {
                Header: "Created",
                accessor: "start_date",
                Cell: (data) => (<div>{moment(data.value).format("L h:mm A")} </div>),
            },
            {
                Header: "Stopped On",
                accessor: "destroyed_date",
                Cell: (data) => (<div>{moment(data.value).format("L h:mm A")} </div>),
            },
            {
                Header: "Stopped by",
                accessor: "destroy_reason"
            },
            {
                Header: "Usage in Hours",
                accessor: "usage_hours"
            }];
        return (
            <div>     
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View User</strong>
                                {user?<Link className="pull-right" to={{pathname: `/updateuser/${this.props.match.params.id}`}}> 
                                    <Button size="sm" color="dark">Edit User</Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div>
                                            {user?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>User Name</td><td>{user.username}</td></tr>
                                                        <tr><td>First Name</td><td>{user.first_name}</td></tr>
                                                        <tr><td>Last Name</td><td>{user.last_name}</td></tr>
                                                        <tr><td>Notes</td><td>{user.notes}</td></tr>
                                                        <tr><td>Locked </td><td>{user.locked?"True":"False"}</td></tr>
                                                        <tr><td>Disabled </td><td>{user.disabled?"True":"False"}</td></tr>
                                                        <tr><td>Organization</td><td>{ user.organization}</td></tr>
                                                        <tr><td>Realm</td><td>{user.realm}</td></tr>
                                                        <tr><td>Last Session</td><td>{moment(user.last_session).format("L h:mm A")}</td></tr>
                                                        <tr><td>Phone</td><td>{user.phone}</td></tr>
                                                        <tr><td>Two Factor Authentication</td><td>{user.two_factor?"True":"False"}</td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody> 
                        </Card>
                                       
                        
                        {user && user.groups && user.groups.length > 0 ?
                            <Card>
                                <div>
                                    <CardHeader><i className="fa fa-align-justify"></i><strong>Groups</strong></CardHeader>
                                    <CardBody>
                                        <ListGroup>{this.renderGroups(user.groups)}</ListGroup>
                                    </CardBody>
                                </div>
                            </Card>
                            :
                            " "
                        }
                        
 
                        {user && user.kasms && user.kasms.length > 0 ?
                            <Card>
                                <div> 
                                    <CardHeader><i className="fa fa-align-justify"></i><strong>User Kasms</strong></CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col xs="11">
                                                <Table bordered responsive className="align_top">
                                                    <thead>
                                                        <tr>
                                                            <th>KeepAlive Date</th>
                                                            <th>Expiration Date</th>
                                                            <th>Start Date</th>
                                                            <th>Agent Host Name</th>
                                                            <th>Agent Id</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{ user ? this.renderKasms(user.kasms) : " "}</tbody>
                                                </Table>   
                                            </Col>
                                        </Row>
                                    </CardBody>             
                                </div>
                            </Card> : " "
                        }

                        { !usageDumpLoading ?
                            <Card>
                                <div>
                                    <CardHeader><i className="fa fa-align-justify"></i><strong>Kasm Usage Details:</strong> Last 30 Days </CardHeader>
                                    <CardBody>
                                        { usageDump ?
                                            <React.Fragment>
                                                <ReactTable
                                                    columns={columns}
                                                    data={usageDump.account_dump}
                                                    defaultSorted={[{id: "date_destroyed", desc: true}]}
                                                    filterable
                                                    defaultPageSize={5}
                                                    className="-striped -highlight site_table"
                                                />
                                            </React.Fragment>
                                            : "No Usage"}
                                    </CardBody>
                                </div>
                            </Card> : " "
                        }

                        <Modal isOpen={this.state.modal} toggle={this.deleteConfirm} className={this.props.className}>
                            <ModalHeader toggle={this.deleteConfirm}>Delete Kasm</ModalHeader>
                            <ModalBody> Confirm Delete Kasm - {"kasm name goes here"}?</ModalBody>
                            <ModalFooter>
                                <Button  onClick={this.deleteKasm} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                                <Button  onClick={this.toggle} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                            </ModalFooter>
                        </Modal>
                    </Col>
                </Row>
            </div>
        );
    }
}

ViewUser.propTypes = {
    history: Proptypes.object.isRequired,
    getUsersId: Proptypes.func.isRequired,
    deleteUserKasm: Proptypes.func.isRequired,
    user: Proptypes.object,
    deleteUserKasmErrorMessage: Proptypes.func,
    deleteUsersKasmError: Proptypes.func,
    match: Proptypes.object,
    className: Proptypes.func
};


export default connect(state =>
    ({
        user: state.admin.user || null,
        deleteUserKasmErrorMessage: state.admin.deleteUserkasmErrorMessage || null,
        deleteUsersKasmError: state.admin.deleteUsersKasmError || null,
        usageDump: state.user.usageDump,
        usageDumpLoading: state.user.usageDumpLoading,
        usageDumpError: state.user.usageDumpError,
    }),
dispatch => 
    ({  
        getUsersId: (data) => dispatch(getUsersId(data)),
        deleteUserKasm: (kasmId) => dispatch(deleteUserKasm(kasmId)),
        getAdminUsageDump: (userId) => dispatch(getAdminUsageDump(userId))
    }))(ViewUser);


// WEBPACK FOOTER //
// ./src/views/AdminUser/ViewUser/ViewUser.js